import Seo from '../components/Seo';
import ArrowLink from '../components/ArrowLink';
import { LogoMark } from '../components/Logo';

export default function NotFoundPage() {
  return (
    <>
      <Seo title="Page Not Found | Build My Trade" description="This page doesn’t exist." path="/404" noindex />
      <section className="flex min-h-[80vh] items-center bg-charcoal bg-blueprint" data-testid="not-found">
        <div className="mx-auto max-w-7xl px-4 py-32 sm:px-6 lg:px-8">
          <LogoMark className="h-12 w-12 text-offwhite" />
          <p className="mt-8 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-lime">404 — page not found</p>
          <h1 className="mt-4 max-w-xl text-balance font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-offwhite sm:text-5xl">
            This page hasn’t been built yet.
          </h1>
          <p className="mt-5 max-w-md text-base leading-relaxed text-offwhite/65">
            The link might be out of date, or the page may have moved. Everything important is on the homepage.
          </p>
          <div className="mt-9 flex flex-wrap gap-4">
            <ArrowLink to="/" variant="lime" testid="notfound-home" className="px-7 py-3.5">
              Back to Homepage
            </ArrowLink>
            <ArrowLink to="/contact" variant="outline-light" testid="notfound-contact" className="px-7 py-3.5">
              Get a Free Quote
            </ArrowLink>
          </div>
        </div>
      </section>
    </>
  );
}
